import React from 'react';
import PropTypes from 'prop-types';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
const { makeStyles, Typography } = MaterialUiCore;
const useStyles = makeStyles((theme) => ({
    root: {
        background: '#fff',
        width: '100%',
        padding: '0.3rem',
        cursor: 'pointer',
    },
    itemGutter: {
        margin: '0.3rem 0',
    },
    itemContainer: {
        margin: '0 1.5rem',
        width: '92%',
        display: 'flex',
        alignItems: 'center',
    },
    itemLabel: {
        fontSize: '1rem',
        fontWeight: 'bold',
    },
    textContent: {
        marginLeft: '0.5rem',
    },
    selected: {
        background: (props) => (props.onSelectBgColor ? props.onSelectBgColor : '#d0419b'),
        position: 'relative',
        display: 'inline-block',
        '&::after': {
            content: "''",
            position: 'absolute',
            top: '50%',
            left: '100%',
            marginTop: '-1.1rem',
            borderWidth: '16px',
            borderStyle: 'solid',
            borderColor: (props) =>
                props.onSelectBgColor
                    ? `transparent transparent transparent ${props.onSelectBgColor}`
                    : 'transparent transparent transparent #d0419b',
        },
    },
}));

const ToggleItemDetails = (props) => {
    const classes = useStyles(props);
    const { params, onSelectItem } = props;
    const { label, value, icon, isItemSelected, customStyle } = params;
    return (
        <Typography
            component="div"
            className={isItemSelected ? `${classes.root}  ${classes.selected}` : classes.root}
            style={customStyle && customStyle.rootStyle}
            onClick={(e) => onSelectItem(params.itemId)}
        >
            <Typography component="div" className={classes.itemGutter} style={customStyle && customStyle.style}>
                <Typography component="div" className={classes.itemContainer}>
                    <Typography component="div">{icon}</Typography>
                    <Typography component="div" className={classes.textContent}>
                        <Typography component="div" className={classes.itemLabel}>
                            {label}
                        </Typography>
                        <Typography component="div" align="left" className={classes.itemLabel}>
                            {value}
                        </Typography>
                    </Typography>
                </Typography>
            </Typography>
        </Typography>
    );
};

ToggleItemDetails.propTypes = {
    params: PropTypes.shape({
        itemId: PropTypes.number.isRequired,
        label: PropTypes.string.isRequired,
        isItemSelected: PropTypes.bool.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        icon: PropTypes.object.isRequired,
        title: PropTypes.object,
        customStyle: PropTypes.object,
    }).isRequired,
    onSelectItem: PropTypes.func,
    onSelectBgColor: PropTypes.string.isRequired,
};
export default ToggleItemDetails;
